/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$( document ).ready(function() {
  if( typeof product_variants_removed != undefined ) {  // was there items to be removed?
    var $addToCartForm = $('form[action="/cart/add"]');
    if (window.MutationObserver && $addToCartForm.length) {
      if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
        observer.disconnect();
      }
      var config = { childList: true, subtree: true };
      //var observer = new MutationObserver(function() {
        product_variants_removed.forEach(function(item){
          $('button[data-value="'+item+'"]').addClass('soldout_option').prop("disabled", true);
          //$('.single-option-selector option').filter(function() { return $(this).text() === item; }).prop('disabled', true);
        });
        //observer.disconnect();
      //});
      //observer.observe($addToCartForm[0], config);
      //$('.single-option-selector').trigger('change');
    }
  }
});